import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchPercentageOfOrigamiSitesProps = {
  startDate: Moment;
  endDate: Moment;
  clusters?: Array<string>;
  partners?: Array<number>;
  origami?: string;
};
export type FetchPercentageOfOrigamiSites = (
  filters: FetchPercentageOfOrigamiSitesProps,
) => void;

const fetchPercentageOfOrigamiSites = ({
  startDate,
  endDate,
  clusters = [],
  partners = [],
  origami,
}: FetchPercentageOfOrigamiSitesProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
    cluster: clusters.length ? "'" + clusters.join("','") + "'" : null,
    partner: partners.join(","),
    enable_origami: origami,
  };
  await fetchReport("percentage_of_origami_sites", dispatch, params);
};

export default fetchPercentageOfOrigamiSites;
